import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';
import barStyles from './Row/Bar/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const StackedBarsLoader = () => /*#__PURE__*/_jsxs("ul", {
  className: styles.container__list,
  children: [/*#__PURE__*/_jsx(RowLoader, {}), /*#__PURE__*/_jsx(RowLoader, {}), /*#__PURE__*/_jsx(RowLoader, {})]
});

const RowLoader = () => /*#__PURE__*/_jsxs("li", {
  className: styles.item,
  children: [/*#__PURE__*/_jsx("span", {
    className: styles.resultTitle,
    children: /*#__PURE__*/_jsx("span", {
      className: styles.itemLoader,
      style: {
        width: '140px'
      }
    })
  }), /*#__PURE__*/_jsxs("div", {
    className: styles.graphic,
    children: [/*#__PURE__*/_jsx(BarLoader, {
      side: "left"
    }), /*#__PURE__*/_jsx(BarLoader, {
      side: "right"
    })]
  })]
});

const BarLoader = _ref => {
  let {
    side
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(barStyles.item, barStyles[`item--${side}`]),
    style: {
      alignItems: 'center'
    },
    children: [side === 'left' ? /*#__PURE__*/_jsx("span", {
      className: clsx(styles.itemLoader, barStyles[`item__amount--${side}`]),
      style: {
        width: '42px'
      }
    }) : null, /*#__PURE__*/_jsx("div", {
      className: clsx(barStyles.bar, barStyles['bar--loading'])
    }), side === 'right' ? /*#__PURE__*/_jsx("span", {
      className: clsx(styles.itemLoader, barStyles[`item__amount--${side}`]),
      style: {
        width: '42px'
      }
    }) : null]
  });
};

export default StackedBarsLoader;